<template>
	<div class="vcx">
		<VcxNav />
		<main id="main-content" class="vcx-page__content">
			<slot />
		</main>
		<!-- cta -->
		<section
			v-scrolled-into-view="MXP_SIV_CTA"
			:data-context="MXP_SIV_CTA['View ID']"
			class="vcx-section vcx-bg-dark-secondary vcx-theme-dark"
		>
			<div class="vcx-container">
				<div class="vcx-cta-section vcx-grid">
					<h2 class="vcx-col-12 vcx-col-6-md vcx-col-7-lg vcx-col-6-xxl vcx-h3 vcx-text-gray-30">
						Sign up to receive updates about VCX
					</h2>
					<VcxLeadCapture
						class="vcx-col-12 vcx-col-6-md vcx-col-offset-6-md vcx-col-5-lg vcx-col-offset-7-lg"
					/>
				</div>
			</div>
		</section>
		<footer
			v-scrolled-into-view="MXP_SIV_FOOTER"
			:data-context="MXP_SIV_FOOTER['View ID']"
			class="vcx-section vcx-bg-dark-secondary vcx-body-md vcx-text-gray-30 vcx-pt-25"
		>
			<div class="vcx-container">
				<hr class="vcx-divider-dark vcx-mb-600" />
				<slot name="footer">
					<BasePlaceHolder :placehold="isSanityLoading" :section-count="5" :line-count="3" theme="dark">
						<RichTextComponent :blocks="vcxFooterDisclaimer" />
					</BasePlaceHolder>
				</slot>
			</div>
		</footer>
	</div>
</template>

<script setup lang="ts">
import '../styles/vcx/vcx.scss';
import { Ref, ref } from 'vue';
import RichTextComponent from '@components/sanity/rich-text-component.vue';
import VcxLeadCapture from '@components/vcx/vcx-lead-capture.vue';
import VcxNav from '@components/vcx/vcx-nav.vue';
import { MXP_SIV_CTA, MXP_SIV_FOOTER } from '@constants/vcx';
import { getVcxFooter } from '@sanity/graphql/vcx-landing-page';
import { SanityRichTextBlock } from 'types/sanity';

const isSanityLoading = ref(true);

const vcxFooterDisclaimer: Ref<Array<SanityRichTextBlock>> = ref([]);

async function setup(): Promise<void> {
	try {
		const vcxLandingPageFooter = await getVcxFooter();
		if (vcxLandingPageFooter) {
			vcxFooterDisclaimer.value = vcxLandingPageFooter;
		}
	} finally {
		isSanityLoading.value = false;
	}
}

setup();
</script>

<style scoped lang="scss">
.vcx {
	min-height: 100vh;
	background-color: var(--vcx-bg-dark);
	font-family: var(--vcx-font-body), serif;
	color: var(--vcx-content-inverse);
}

.vcx-page__content {
	padding-top: 78px;
	overflow-x: hidden;
	overscroll-behavior-x: contain;

	.vcx-nav--mobile ~ & {
		padding-top: 0;
	}
}

.vcx footer {
	padding-bottom: var(--vcx-space-600);
	ol {
		margin-top: var(--vcx-space-150);
		margin-left: var(--vcx-space-150);
		list-style: decimal;
		li {
			display: list-item;
		}
	}
	:deep(.text-link) {
		color: var(--vcx-content-inverse);
		text-decoration: underline;
		text-underline-offset: 2px;
		&:hover {
			color: var(--vcx-content-inverse-secondary);
		}
	}
}
</style>
